import { DestroyRef, Directive, HostListener, inject } from '@angular/core';
import { BreakpointObserver, type BreakpointState } from '@angular/cdk/layout';
import { type Observable, take } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';

import { AppFacade } from '@web/store/app/app.facade';
import { LayoutFacade } from '@web/store/layout/layout.facade';
import { SiteFacade } from '@web/store/website/site/site.facade';

@Directive()
export abstract class BaseDrawerComponent {
    protected readonly appFacade: AppFacade = inject(AppFacade);
    protected readonly siteFacade: SiteFacade = inject(SiteFacade);
    protected readonly layoutFacade: LayoutFacade = inject(LayoutFacade);
    protected readonly breakpointObserver = inject(BreakpointObserver);
    protected readonly destroyRef = inject(DestroyRef);

    @HostListener('window:keydown.esc', ['$event'])
    public handleKeyDown(event: KeyboardEvent): void {
        this.showDrawer$
            .pipe(
                take(1),
                filter((value) => value),
                tap(() => {
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    event.preventDefault();
                })
            )
            .subscribe(() => {
                this.closeDrawer();
            });
    }

    public abstract readonly showDrawer$: Observable<boolean>;

    public readonly isAdmin$ = this.appFacade.isAdmin$;
    public readonly isMobile$ = this.breakpointObserver
        .observe(['(max-width: 479px)'])
        .pipe(map((state: BreakpointState) => state.matches));

    public readonly site$ = this.siteFacade.site$;
    public readonly isSaving$ = this.siteFacade.isSaving$;

    public closeDrawer(): void {
        this.layoutFacade.closeDrawer();
    }
}
